import(/* webpackMode: "eager" */ "/home/runner/work/joyboy/joyboy/libs/shared/observability/src/lib/client-logging.ts");
;
import(/* webpackMode: "eager" */ "/home/runner/work/joyboy/joyboy/node_modules/.pnpm/next@14.2.15_@babel+core@7.28.3_@opentelemetry+api@1.9.0_@playwright+test@1.55.0_babel-plugin_y65pd5kuvbybifrlyr224txzi4/node_modules/next/dist/client/link.js");
